import React from "react";

export default function NotFound() {
  return <div>Favor ingresar ruta válida</div>;
}
